import {
  Button,
  Box,
  Grid,
  Typography,
  useMediaQuery,
  PaginationItem,
  Pagination,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Tooltip,
} from "@mui/material";
import GetBranchDetails from "../CustomComponents/GetBranchDetails";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import AccordianContainer from "../CustomComponents/AccordianContainer";
import CustomTextField from "../CustomComponents/CustomTextField";
import StlapFooter from "../CustomComponents/StlapFooter";
import CustomAutoComplete from "../CustomComponents/CustomAutoComplete";
import CustomDateField from "../CustomComponents/CustomDateField";
import axios from "axios";
import { BranchAction } from "../Store/Branch";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import NachRetrievalList from "../Nach/NachRetrievalList";
import { SpecialAccessDetailAction } from "../Store/SpecialAccess/SpecialAccessDetailReducer";
import { CommonShortCutAction } from "../Store/CommonShortCutsReducer";
import { useRef } from "react";
import store from "../Store";

const Posting = () => {
  const [modeOfOperation, setModeOfOperation] = useState("");
  const [modeOfOperationList, setModeOfOperationList] = useState([]);
  const [sponserBank, setSponserBank] = useState("");
  const [sponserBankList, setSponserBankList] = useState([]);
  const [dueDate, setDueDate] = useState("");
  const [dueDateEnable, setDueDateEnable] = useState(false);
  const [voucherDate, setVoucherDate] = useState("");
  const [depositBankList, setDepositBankList] = useState([]);
  const [modeOfOperationError, setModeofOperationError] = useState(false);
  const [spronserBankError, setSpronserBankError] = useState(false);
  const [voucherDateError, setVoucherDateError] = useState(false);
  const [dueDateError, setDueDateError] = useState(false);
  const [openPostDialog, setOpenPostDialog] = useState(false);
  const [postMessage, setPostMessage] = useState("");
  const [postingDateTime, setPostingDateTime] = useState("");
  const userName = useSelector((state) => state.branch.userName);
  const [depositBankAccount, setDepositBankAccount] = useState("");
  const [depositBankCode, setDepositBankCode] = useState("");
  const [depositBank, setDepositBank] = useState("");
  const [depositBankError, setDepositBankError] = useState(false);
  const [dueValidDateError, setDueValidDateError] = useState(false);
  const [voucherValidDateError, setVoucherValidDateError] = useState(false);
  const userId = store.getState().branch.userID;
  const moduleId = useSelector((state) => state.specialAccess.moduleId);
  const programId = useSelector((state) => state.specialAccess.programId);
  let fieldAccessMap = useSelector(
    (state) => state.specialAccess.fieldAccessMap
  );
  let paramValues = useSelector((state) => state.specialAccess.paramValues);
  const dispatch = useDispatch();
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [alert, setAlert] = useState(false);
  //Branch onChangeHandler
  useEffect(() => {
    getFieldData();
  }, []);

  const getFieldData = async () => {
    let modeIdVal = "";
    const response = await axios.get("/specialAccess/getFieldAccess", {
      method: "get",
      params: {
        userId: userId,
        moduleId: moduleId,
        programId: programId,
        modeId: modeIdVal,
      },
    });
    dispatch(SpecialAccessDetailAction.getFieldData(response.data));
  };
  let minDateFromValue = Number(0);
  let maxDateFromValue = Number(0);

  if (
    paramValues !== null &&
    paramValues !== undefined &&
    Object.keys(paramValues).length > 0
  ) {
    if (
      !(
        paramValues["Nach Posting Request Date Back Count"] &&
        new Date(
          paramValues["Nach Posting Request Date Back Count"][
            "paramEffStartDate"
          ]
        ) <= new Date(dayjs(new Date()).format("MM/DD/YYYY")) &&
        new Date(
          paramValues["Nach Posting Request Date Back Count"]["paramEffEndDate"]
        ) >= new Date(dayjs(new Date()).format("MM/DD/YYYY"))
      )
    ) {
      minDateFromValue = 0;
    } else {
      minDateFromValue =
        fieldAccessMap.nachPostingDate && fieldAccessMap.nachPostingBackCount
          ? Number(
              paramValues["Nach Posting Request Date Back Count"]["paramValue"]
            )
          : Number(0);
    }
    if (
      !(
        paramValues["Nach Posting Request Date Future Count"] &&
        new Date(
          paramValues["Nach Posting Request Date Future Count"][
            "paramEffStartDate"
          ]
        ) <= new Date(dayjs(new Date()).format("MM/DD/YYYY")) &&
        new Date(
          paramValues["Nach Posting Request Date Future Count"][
            "paramEffEndDate"
          ]
        ) >= new Date(dayjs(new Date()).format("MM/DD/YYYY"))
      )
    ) {
      maxDateFromValue = 0;
    } else {
      maxDateFromValue =
        fieldAccessMap.nachPostingDate && fieldAccessMap.nachPostingFutureCount
          ? Number(
              paramValues["Nach Posting Request Date Future Count"][
                "paramValue"
              ]
            )
          : Number(0);
    }
  }

  //shortcut key
  const saveRef = useRef(null);
  const clearRef = useRef(null);
  const okRef = useRef(null);
  useEffect(() => {
    getInitialData();
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, [dueDateEnable]);
  useEffect(() => {
    getModeOfOperation();
  }, []);
  const getModeOfOperation = async () => {
    try {
      const nachLovValues = await axios.post("/lovMaster/getLovValues", {
        moduleId: "MD002",
      });
      const modesOfOperation = nachLovValues.data["Mode of Operation"].map(
        (type) => {
          return {
            label: type.lovValues,
          };
        }
      );
      setModeOfOperationList(modesOfOperation);
    } catch (e) {}
  };
  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "nachPosting",
        })
      );
    }
  };
  const onKeyPressEventHandler = (event) => {
    if (event.key === "Escape" || event.keyCode === 27) {
      // on escape press close the dialog.
      setOpenPostDialog(false);
    }
    let refList = { saveRef: saveRef, clearRef: clearRef, okRef: okRef };
    let charCode = String.fromCharCode(event.which).toLowerCase();
    let date = new Date();
    if (event.ctrlKey) {
      if (charCode === "o") {
        date.setDate(date.getDate() + 1);
        dueDateEnable && setDueDate(date);
      } else if (charCode === "i") {
        dueDateEnable && setDueDate(new Date());
      } else {
        dispatch(
          CommonShortCutAction.getShortCutValue({
            event: event,
            refs: refList,
            screen: "nachPosting",
          })
        );
      }
    }
  };
  const setValueToFlag = () => {
    setDueDateEnable(true);
  };
  const ClearButtonHandler = () => {
    setModeOfOperation("");
    setSponserBank("");
    setDepositBank("");
    setDepositBankError(false);
    setSpronserBankError(false);
    setDueDateError(false);
    setDueDate(null);
    setPostingDateTime("");
    setVoucherDate(null);
    setVoucherDateError(false);
    setModeofOperationError(false);
    setDepositBankAccount("");
    setVoucherDateError(false);
  };
  const formSponcerBankList = (losSponcerBankList) => {
    var sponcerBankLists = [];
    losSponcerBankList.forEach((sponserBankMap) => {
      let bankMap = {};
      bankMap["label"] = sponserBankMap["bank_name"];
      bankMap["value"] = sponserBankMap["bank_code"];
      sponcerBankLists.push(bankMap);
    });
    return sponcerBankLists;
  };
  const formDepositBankList = (losDepositBank) => {
    var depositBankLists = [];
    losDepositBank.forEach((depositBankMap) => {
      let bankMap = {};
      bankMap["label"] = depositBankMap["branch_name"];
      bankMap["value"] = depositBankMap["bank_branch_key"];
      bankMap["bankCode"] = depositBankMap["gl_account"];
      depositBankLists.push(bankMap);
    });
    return depositBankLists;
  };
  const getInitialData = () => {
    loadSponcerBankList();
    loadDepositBankList();
  };
  const loadDepositBankList = async (response) => {
    const dataMap = {
      apiCode: "BANK_CASH_ACCOUNT_API",
      createdBy: userName,
      branchCode: "999",
    };
    try {
      // const response = await axios(
      const response = await axios.post("/api/getDepositBankFromlos", dataMap);
      if (response.data.status === 1) {
        setDepositBankList(formDepositBankList(response.data.ledger_details));
      }
    } catch {
      console.log("Network Error");
    }
  };
  const loadSponcerBankList = async (response) => {
    const dataMap = { apiCode: "SPONSOR_BANK_LOV_API", createdBy: userName };
    try {
      // const response = await axios(
      const response = await axios.post("/api/getSponserBankFromlos", dataMap);
      if (response.data.status === 1) {
        setSponserBankList(
          formSponcerBankList(response.data.sponsor_bank_dtls)
        );
      }
    } catch {
      console.log("Network Error");
    }
  };
  const loadPostingData = async () => {
    if (
      !modeOfOperation ||
      !sponserBank ||
      !voucherDate ||
      !dueDate ||
      !depositBank ||
      voucherValidDateError ||
      dueValidDateError
    ) {
      !sponserBank ? setSpronserBankError(true) : setSpronserBankError(false);
      !modeOfOperation
        ? setModeofOperationError(true)
        : setModeofOperationError(false);
      !dueDate ? setDueDateError(true) : setDueDateError(false);
      // !voucherDate ? setVoucherDateError(true) : setVoucherDateError(false);
      !depositBank ? setDepositBankError(true) : setDepositBankError(false);
    } else {
      const dataMap = {
        modeOfOperation: modeOfOperation.label,
        sponsorBank: sponserBank.label,
        dueDate: dueDate,
        voucherDate: voucherDate,
        depositBank: depositBank.label,
        debitAccCode: depositBankAccount,
        debitBankCode: depositBankCode,
        userName: userName,
      };
      try {
        // const response = await axios(
        const response = await axios.post(
          "/retrievalposting/postRetrievedData",
          dataMap
        );
        if (response.data) {
          setPostMessage(response.data.msg);
          setOpenPostDialog(true);
          response.data.postingDate
            ? setPostingDateTime(
                new Date(response.data.postingDate)
                  .toLocaleDateString("en-GB")
                  .toString() +
                  " " +
                  new Date(response.data.postingDate)
                    .toLocaleTimeString("en-IN", { hour12: false })
                    .toString()
              )
            : setPostingDateTime("");
          handleDownload(response.data.voucherList);
        }
      } catch {
        console.log("Network Error");
      }
    }
  };

  const openAlertHandler = () => {
    setAlert(true);
  };

  const handleDownload = (voucherList) => {
    try {
      axios
        .post("/retrievalposting/downloadPostingData", voucherList, {
          method: "POST",
          responseType: "blob",
        })
        .then((response) => {
          if (response.status === 200) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `Nach_Posting.xls`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setMessage("Nach Posting File Downloaded Success.");
            setAlertType("success");
            openAlertHandler();
          } else if (response.status === 206) {
            setMessage("No Data Found to download");
            setAlertType("error");
            openAlertHandler();
          }
        });
    } catch (error) {
      setMessage("Nach Posting File Downloaded Failed.");
      setAlertType("error");
      openAlertHandler();
      throw Error(error);
    }
  };

  return (
    <>
      <div style={{ minHeight: "calc(100vh - 120px)" }}>
        <Box>
          <AccordianContainer
            id="accord"
            title="Posting Details"
            initialOpen={true}
            sx={{ margin: "8px !important" }}
          >
            <Grid spacing={1} container sx={{ marginTop: "-36px !important" }}>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomAutoComplete
                  variant="standard"
                  type="text"
                  id="modeOfOperation"
                  placeholder="Select Mode Of Operation"
                  label="Mode of Operation"
                  required={true}
                  autoCompleteValues={modeOfOperationList}
                  value={modeOfOperation}
                  onChange={(event, newValue) => {
                    setModeOfOperation(newValue);
                    newValue
                      ? setModeofOperationError(false)
                      : setModeofOperationError(true);
                  }}
                  onBlur={(event) => {
                    modeOfOperation
                      ? setModeofOperationError(false)
                      : setModeofOperationError(true);
                  }}
                />
                {modeOfOperationError && (
                  <p className="error">Please Select Mode Of Operation</p>
                )}
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomAutoComplete
                  disabled={false}
                  required={true}
                  variant="standard"
                  type="text"
                  placeholder="Select Sponsor Bank"
                  label="Sponsor Bank"
                  id="sponserBank"
                  autoCompleteValues={sponserBankList}
                  value={sponserBank}
                  onChange={(event, value) => {
                    setSponserBank(value);
                    value
                      ? setSpronserBankError(false)
                      : setSpronserBankError(true);
                  }}
                  onBlur={(event) => {
                    sponserBank
                      ? setSpronserBankError(false)
                      : setSpronserBankError(true);
                  }}
                />
                {spronserBankError && (
                  <p className="error">Please Select Sponsor Bank</p>
                )}
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomAutoComplete
                  variant="standard"
                  required={true}
                  disabled={false}
                  type="text"
                  placeholder="Select Deposit Bank"
                  label="Deposit Bank"
                  id="depositeBank"
                  defaultValue="HDFC"
                  autoCompleteValues={depositBankList}
                  value={depositBank}
                  onChange={(event, value) => {
                    setDepositBank(value);
                    setDepositBankAccount(value ? value.value : "");
                    setDepositBankCode(value ? value.bankCode : "");
                    value
                      ? setDepositBankError(false)
                      : setDepositBankError(true);
                  }}
                  onBlur={(event) => {
                    depositBank
                      ? setDepositBankError(false)
                      : setDepositBankError(true);
                  }}
                />
                {depositBankError && (
                  <p className="error">Please Select Deposit Bank</p>
                )}
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomDateField
                  label="Due Date"
                  required={true}
                  id="dueDate"
                  variant="standard"
                  minDate={new Date().setDate(
                    new Date().getDate() - minDateFromValue
                  )}
                  maxDate={new Date().setDate(
                    new Date().getDate() + maxDateFromValue
                  )}
                  value={dueDate}
                  type="text"
                  placeholder="Due Date"
                  onOpen={setValueToFlag}
                  onChange={(event, value) => {
                    var today = new Date();

                    event ? setDueDate(new Date(event)) : setDueDate(null);
                    event
                      ? setVoucherDate(new Date(event))
                      : setVoucherDate(null);
                    setVoucherDateError(false);
                    setDueDateError(false);
                    new Date(event)
                      ? setDueDateError(false)
                      : setDueDateError(true);
                    new Date(event).toDateString() !== "Invalid Date" &&
                    event !== null &&
                    new Date(event).toLocaleDateString().slice(-4) >= "1970" &&
                    new Date(event).toLocaleDateString().slice(-4) <= "2055"
                      ? setDueValidDateError(false)
                      : setDueValidDateError(true);

                    const newDateValue = `${new Date(event).getFullYear()}/${
                      new Date(event).getMonth() + 1 > 9
                        ? new Date(event).getMonth() + 1
                        : "0" + new Date(event).getMonth() + 1
                    }/${
                      new Date(event).getDate() > 9
                        ? new Date(event).getDate()
                        : "0" + new Date(event).getDate()
                    }`;
                    const maxValue = new Date().setDate(
                      new Date().getDate() + maxDateFromValue
                    );
                    const maxDateValue = `${new Date(maxValue).getFullYear()}/${
                      new Date(maxValue).getMonth() + 1 > 9
                        ? new Date(maxValue).getMonth() + 1
                        : "0" + new Date(maxValue).getMonth() + 1
                    }/${
                      new Date(maxValue).getDate() > 9
                        ? new Date(maxValue).getDate()
                        : "0" + new Date(maxValue).getDate()
                    }`;

                    const minValue = new Date().setDate(
                      new Date().getDate() - minDateFromValue
                    );
                    const minDateValue = `${new Date(minValue).getFullYear()}/${
                      new Date(minValue).getMonth() + 1 > 9
                        ? new Date(minValue).getMonth() + 1
                        : "0" + new Date(minValue).getMonth() + 1
                    }/${
                      new Date(minValue).getDate() > 9
                        ? new Date(minValue).getDate()
                        : "0" + new Date(minValue).getDate()
                    }`;
                    const specialAccessMaxFlag = newDateValue <= maxDateValue;
                    const specialAccessMinFlag = newDateValue >= minDateValue;
                    specialAccessMaxFlag && specialAccessMinFlag
                      ? setDueValidDateError(false)
                      : setDueValidDateError(true);
                  }}
                  onBlur={(event) => {
                    if (dueDate) {
                      setDueDateError(false);
                    } else {
                      setDueDateError(true);
                      setDueValidDateError(false);
                    }
                  }}
                />
                {dueDateError && <p className="error">Please Enter Due Date</p>}
                {dueValidDateError && (
                  <p className="error">Please Enter Valid Date</p>
                )}
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomDateField
                  required={false}
                  label="Voucher Date"
                  id="voucherDate"
                  disabled={true}
                  disablePast={true}
                  variant="standard"
                  value={voucherDate}
                  // minDate={"1970/01/01"}
                  // maxDate={"2055/12/31"}
                  type="text"
                  placeholder="Voucher Date"
                  onChange={(event) => {
                    var today = new Date();
                    var givenYear = new Date(event).getFullYear();
                    var givenMonth = new Date(event).getMonth() + 1; // Adding 1 because month is zero-based
                    var givenDay = new Date(event).getDate();

                    // Extract year, month, and day values from today's date
                    var todayYear = today.getFullYear();
                    var todayMonth = today.getMonth() + 1;
                    var todayDay = today.getDate();

                    let deactivationDateValidationFlag;
                    if (givenYear > todayYear) {
                      deactivationDateValidationFlag = true;
                    } else if (
                      givenYear === todayYear &&
                      givenMonth > todayMonth
                    ) {
                      deactivationDateValidationFlag = true;
                    } else if (
                      givenYear === todayYear &&
                      givenMonth === todayMonth &&
                      givenDay >= todayDay
                    ) {
                      deactivationDateValidationFlag = true;
                    } else {
                      deactivationDateValidationFlag = false;
                    }
                    event
                      ? setVoucherDate(new Date(event))
                      : setVoucherDate(null);
                    setVoucherDateError(false);
                    new Date(event)
                      ? setVoucherDateError(false)
                      : setVoucherDateError(true);
                    new Date(event).toDateString() !== "Invalid Date" &&
                    event !== null &&
                    new Date(event).toLocaleDateString().slice(-4) >= "1970" &&
                    new Date(event).toLocaleDateString().slice(-4) <= "2055" &&
                    deactivationDateValidationFlag
                      ? setVoucherValidDateError(false)
                      : setVoucherValidDateError(true);
                  }}
                  onBlur={(event) => {
                    if (voucherDate) {
                      setVoucherDateError(false);
                    } else {
                      setVoucherDateError(true);
                      setVoucherValidDateError(false);
                    }
                  }}
                />
                {voucherDateError && (
                  <p className="error">Please Enter Voucher Date</p>
                )}
                {voucherValidDateError && (
                  <p className="error">Please Enter Valid Date</p>
                )}
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomTextField
                  type="text"
                  disabled={true}
                  label="Debit Account Code"
                  variant="standard"
                  value={depositBankAccount}
                  placeholder="Debit Account Code"
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomTextField
                  type="text"
                  label="Posting Date"
                  variant="standard"
                  placeholder="Posting Date"
                  value={postingDateTime}
                  disabled={true}
                />
              </Grid>
            </Grid>
            <Box
              sx={{
                marginTop: "6px",
                marginBottom: "2px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Tooltip title="Ctrl+S" placement="top">
                <Button
                  variant="contained"
                  type="submit"
                  sx={{ height: "2rem" }}
                  onClick={loadPostingData}
                  ref={saveRef}
                >
                  Post
                </Button>
              </Tooltip>
              <Tooltip title="Ctrl+D" placement="top">
                <Button
                  sx={{
                    marginLeft: "6px",
                    color: "white",
                    backgroundColor: "black",
                    height: "2rem",
                  }}
                  onMouseOver={({ target }) => {
                    target.style.backgroundColor = "black";
                    target.style.color = "white";
                  }}
                  variant="contained"
                  onClick={ClearButtonHandler}
                  ref={clearRef}
                >
                  Clear
                </Button>
              </Tooltip>
            </Box>
          </AccordianContainer>
          <Dialog
            open={openPostDialog}
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle>{"Information"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                {" "}
                {postMessage}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Tooltip title="Ctrl+K" placement="top">
                <Button
                  sx={{ fontWeight: "bold" }}
                  onClick={() => {
                    setOpenPostDialog(false);
                    ClearButtonHandler();
                  }}
                  ref={okRef}
                >
                  OK
                </Button>
              </Tooltip>
            </DialogActions>
          </Dialog>
          {/* <NachRetrievalList /> */}
        </Box>
      </div>
      <Box>
        <StlapFooter />
      </Box>
    </>
  );
};
export default Posting;
